import React from 'react'
import './PhotoGallery.css'
import imges1 from './Photo1.jpg'
import imges2 from './Photo2.jpg'
import imges3 from './Photo3.jpg'
import imges4 from './Photo4.jpg'
import imges5 from './Photo5.jpg'

const PhotoGallery = () => {
  return (
    
      <div className='main-photo'> 
        <div className='photo-one'>
       <img className='imges' src={imges1} alt='img'></img>
       <img className='imges' src={imges2} alt='img'></img>
       <p className='photop'><span>Germany Hannover Exibition</span></p>
       </div>

       <div className='photo-two'>
       <img className='imges' src={imges3} alt='img'></img>
       <img className='imges' src={imges4} alt='img'></img>
       <img className='imges' src={imges5} alt='img'></img>
       <p className='photop'><span>Dealers Meet 2018</span></p>
       </div>
      </div>
   
  )
}

export default PhotoGallery
